export const COLORS = {
  primary: 0xf5a623, // Oranye
  secondary: 0x4a90e2, // Biru
  success: 0x4caf50, // Hijau
  danger: 0xe74c3c, // Merah
  ink: 0x1a1a1a, // Hitam
  paper: 0xffffff, // Putih
  mute: 0x9e9e9e, // Abu
  accent: 0xffc107, // Kuning,
}

export const FONT = {
  family: '"Quicksand", "Nunito", system-ui, sans-serif',
  sizeTitle: 32,
  sizeBody: 20,
  sizeCaption: 14,
  sizeButton: 22,
  weightBold: 'bold',
}

export const SIZE = {
  W: 720,
  H: 1280,
  tile: 80,
  safeTop: 80,
  safeBottom: 120,
  // Touch target minimum untuk anak 6–8 th
  minTapTargetDp: 56,
}

export const BLOCK_COLORS = {
  events: '#f5a623', // kuning
  motion: '#4a90e2', // biru
  looks: '#9966cc', // ungu
  sound: '#4caf50', // hijau
  logic: '#ff8c00', // oranye tua
  loop: '#ff6f61', // coral
  end: '#e74c3c', // merah
}

export const GRID = {
  spacing: 24,
  length: 2,
  snap: true,
  colour: '#E5E7EB',
}

export const BLOCK_SIZES = {
  minHeight: 40,
  padding: 8,
  workspacePadding: 16,
  mobileFlyoutHeight: 64,
}
